import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogHighlight',
})(({ spacing, breakpoints, brandColors, type, typography }) => ({
  spacingContainer: {
    backgroundColor: brandColors.tintsHeroBlue90,
  },
  container: {
    width: '100%',
    position: 'relative',
  },
  swiper: {
    marginTop: spacing(2),
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: spacing(2),
    gap: spacing(2),

    [breakpoints.up('md')]: {
      gap: spacing(3),
    },
    [breakpoints.up('lg')]: {
      gap: spacing(2),
    },
  },
  blogCta: {
    ...type['16_regular'],
    display: 'flex',
    width: '100%!important',
    justifyContent: 'center',
    marginTop: spacing(1),
    '& > div': {
      width: typography.pxToRem(16),
    },
    [breakpoints.up('sm')]: {
      width: 'fit-content!important',
      marginLeft: 'auto',
    },
    [breakpoints.up('md')]: {
      marginTop: spacing(2),
    },
  },
  navigation: {
    display: 'flex',
    justifyContent: 'center',
    gap: spacing(3),
    marginTop: spacing(2),
    cursor: 'pointer',
  },
  navigationButton: {
    width: typography.pxToRem(40),
    height: typography.pxToRem(40),
    [breakpoints.up('sm')]: {
      width: typography.pxToRem(60),
      height: typography.pxToRem(60),
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: typography.pxToRem(800),
    border: `${typography.pxToRem(1)} solid ${brandColors.primaryMain}`,
    color: brandColors.primaryMain,
    borderColor: brandColors.primaryMain,
  },
  navigationButtonDisabled: {
    opacity: 0.3,
  },
  hidden: {
    visibility: 'hidden',
  },
  horizontal: {
    display: 'flex',
  },
  pagination: {
    width: 'fit-content!important',
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0),
    '& .bullet': {
      color: brandColors.tintsHeroBlue80,
    },
    '& .bullet-active': {
      color: brandColors.primaryMain,
    },
  },
}));

export default useStyles;
